import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    useTheme,
    useMediaQuery,
    Button,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { Menu as MenuIcon, ExitToApp as LogoutIcon, AccessTime as AccessTimeIcon, CalendarMonth as CalendarIcon } from '@mui/icons-material';
import AdminMenu from '../components/AdminMenu';
import { authService } from '../services/authService';
import { Link } from 'react-router-dom';

const DRAWER_WIDTH = 240;

const AdminLayout: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleLogout = async () => {
        try {
            await authService.logout();
            navigate('/admin/login');
        } catch (error) {
            console.error('Çıkış yapılırken hata oluştu:', error);
        }
    };

    const drawer = (
        <Box sx={{ mt: isMobile ? 0 : 8 }}>
            <AdminMenu />
            <ListItemButton component={Link} to="/admin/calendar">
                <ListItemIcon>
                    <CalendarIcon />
                </ListItemIcon>
                <ListItemText primary="Takvim" />
            </ListItemButton>
            <ListItemButton component={Link} to="/admin/timeslots">
                <ListItemIcon>
                    <AccessTimeIcon />
                </ListItemIcon>
                <ListItemText primary="Çalışma Saatleri" />
            </ListItemButton>
        </Box>
    );

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar
                position="fixed"
                sx={{
                    width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
                    ml: { md: `${DRAWER_WIDTH}px` },
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <Toolbar sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    minHeight: { xs: 56, sm: 64 }
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { md: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div">
                            Admin Panel
                        </Typography>
                    </Box>
                    <Button
                        color="inherit"
                        onClick={handleLogout}
                        startIcon={<LogoutIcon />}
                        sx={{ display: { xs: 'none', sm: 'flex' } }}
                    >
                        Çıkış Yap
                    </Button>
                    <IconButton
                        color="inherit"
                        onClick={handleLogout}
                        sx={{ display: { sm: 'none' } }}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Box
                component="nav"
                sx={{ width: { md: DRAWER_WIDTH }, flexShrink: { md: 0 } }}
            >
                {/* Mobil çekmece */}
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Mobil performansı için
                    }}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: DRAWER_WIDTH,
                            mt: isMobile ? '56px' : 0,
                        },
                    }}
                >
                    {drawer}
                </Drawer>

                {/* Masaüstü çekmece */}
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: DRAWER_WIDTH,
                        },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 2, md: 3 },
                    width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
                    mt: { xs: '56px', sm: '64px' },
                    overflowX: 'hidden',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout; 